import { createContext } from 'react';
import { DisputeStep } from './types';

export interface IDisputeContext {
  onSaveDraft: () => Promise<void>;
  onSend: () => Promise<void>;
  onReject: () => Promise<void>;
  onSuccessSubmit: () => Promise<void>;
  activeStep: DisputeStep;
  setActiveStep: React.Dispatch<React.SetStateAction<DisputeStep>>;
  onDownloadInvoiceReport: () => Promise<void>;
  onClose: () => void;
  setIsDisableSave: (status: boolean) => void;
  isSummaryAcceptOrReject: boolean;
  isDisableSave: boolean;
}

export const DisputeContext = createContext<IDisputeContext>(null);
